/*!
 * @file Docist Code Highlighting (entry)
 * @description Bundles Highlight.js (full build v11.11.1) with Docist's custom code controls.
 * Initializes syntax highlighting and then injects Docist controls (wrap/copy).
 * Entry point: compiled into assets/dist/js/docist-code-highlighting.js
 * License note: Highlight.js v11.11.1 → BSD-3-Clause (© Josh Goebel & contributors)
 * @package Docist
 * @since 1.0.0
 * @version 1.0.0
 */

import hljs from './highlight.js';
import { initDocistHighlighting } from './docist-code-controls.js';

/**
 * Highlight all <pre><code> blocks and then attach Docist controls.
 * HLJS runs first so classes like .language-XYZ are present for labels.
 *
 * @since 1.0.0
 * @returns {void}
 */
function enhanceAll() {
	hljs.highlightAll();
	// Defer controls to next frame to ensure DOM/class updates have landed.
	requestAnimationFrame(initDocistHighlighting);
}

/**
 * Boot on DOM ready.
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', enhanceAll);
